import { ABP, eLayoutType } from '@abp/ng.core';

export const OFERTAS_ABERTAS_BASE_ROUTES: ABP.Route[] = [
  {
    path: '/ofertas-abertas',
    iconClass: 'fas fa-hammer',
    name: 'Leilão',
    layout: eLayoutType.application,
    requiredPolicy: 'cargo_fleet.Ofertas',
    order: 0
  },
];
